import { IServedAd, IServedAdEvent } from 'types';
import { getHeaderOptions, getHttpService } from './http-service';

const httpClient = getHttpService();

const AD_SERVICE_BASE_ROUTE = '/ads';

/**
 * Which partner ads (if any) to show on the waiting screen for this scan.
 * The backend applies the campaign's policy-type targeting, schedule,
 * impression cap, serve percentage and A/B variant — the client just
 * renders what it gets. The scan keys let the backend read the scan's
 * policy type itself; `policyType` is the fallback while the row lands.
 */
export const getActivePartnerAds = async (
  policyType?: string,
  scan?: { policyScanId?: string; policyId?: string },
): Promise<IServedAd[]> => {
  const params: Record<string, string> = {};
  if (policyType) params.policyType = policyType;
  if (scan?.policyScanId) params.policyScanId = scan.policyScanId;
  if (scan?.policyId) params.policyId = scan.policyId;

  const { data } = await httpClient.get(`${AD_SERVICE_BASE_ROUTE}/active`, {
    headers: getHeaderOptions(),
    params: Object.keys(params).length ? params : undefined,
  });
  return Array.isArray(data?.ads) ? data.ads : [];
};

/** Impression / click for a served ad. Fire-and-forget from the UI. */
export const recordPartnerAdEvent = (event: IServedAdEvent) => {
  return httpClient.post(`${AD_SERVICE_BASE_ROUTE}/events`, event, {
    headers: getHeaderOptions(),
  });
};
